import * as Scrivito from "scrivito";
import I18n from "^/config/i18n";

function FavLinks({ links }) {
  if (links.length === 0) {
    return null;
  }
  return (
    <div className="py-4 footer-links">
      <div className="container">
        <div className="pb-1">
          <strong>{I18n.t("Footer favourite links")}</strong>
        </div>
        <ul id="footer__favorite-links">
          {links.map((link, index) => (
            <li key={index}>
              <Scrivito.LinkTag to={link}>
                {link.title() ||
                  (link.isInternal() ? link.obj().get("title") : link.url())}
              </Scrivito.LinkTag>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
export default Scrivito.connect(FavLinks);
